import { h } from 'preact'

export default ({ size = 24, fill }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={fill || "var(--md-gray-950)"} d="M24 13H15V4C15 3.447 14.553 3 14 3C13.447 3 13 3.447 13 4V13H4C3.447 13 3 13.447 3 14C3 14.553 3.447 15 4 15H13V24C13 24.553 13.447 25 14 25C14.553 25 15 24.553 15 24V15H24C24.553 15 25 14.553 25 14C25 13.447 24.553 13 24 13Z" />
    </svg>
)